import { ref } from 'vue'

/**
 * Estado global de "carregando" acionado pelas requisições HTTP (interceptors do axios).
 * Equivale ao <p:ajaxStatus onstart=show / oncomplete=hide> do legado (WEB-INF/template.xhtml),
 * que mostrava o dialog "Aguarde Processamento" em qualquer requisição ajax.
 *
 * Usa um contador de requisições pendentes (suporta chamadas concorrentes) e só exibe o overlay
 * depois de um pequeno atraso, para não "piscar" em respostas rápidas (ex.: autocomplete).
 */
const pendentes = ref(0)
export const carregando = ref(false)

const ATRASO_MS = 250
let timer: ReturnType<typeof setTimeout> | null = null

export function iniciarCarregamento() {
  pendentes.value++
  if (pendentes.value === 1 && timer === null) {
    timer = setTimeout(() => {
      timer = null
      if (pendentes.value > 0) carregando.value = true
    }, ATRASO_MS)
  }
}

export function finalizarCarregamento() {
  if (pendentes.value > 0) pendentes.value--
  if (pendentes.value === 0) {
    if (timer !== null) {
      clearTimeout(timer)
      timer = null
    }
    carregando.value = false
  }
}

/**
 * Zera o estado de carregamento ao trocar de rota.
 *
 * Chamadas HTTP da página anterior podem continuar em voo depois da navegação
 * (ex.: GET /api/avisos da home ainda pendente enquanto o usuário abre Cadastro de Avisos).
 * Nesse caso pendentes > 0 e o LoadingOverlay cobre a nova página inteira — o usuário vê
 * tela "em branco" até a chamada antiga terminar (até 250 s de timeout).
 *
 * O reset antecipa o clearTimeout e zera o contador; finalizarCarregamento das chamadas
 * antigas é inofensivo porque o guard `if (pendentes.value > 0)` evita valores negativos.
 */
export function resetCarregamento() {
  if (timer !== null) {
    clearTimeout(timer)
    timer = null
  }
  pendentes.value = 0
  carregando.value = false
}
